import React from 'react';
import { useSelector } from 'react-redux';
import useCurrentCategory from './useCurrentCategory';

export const useLensAdvisor = () => {
  const lensAdvisorModule = useSelector(
    (state: any) => state.config?.lensAdvisorModule
  );
  const laExperience = useSelector(
    (state: any) => state.config?.lensAdvisorModule?.laExperience
  );
  const currentType = useCurrentCategory();

  if (
    lensAdvisorModule &&
    laExperience === true &&
    currentType !== 'SUNGLASSES'
  ) {
    return true;
  }
};
